module.exports = __webpack_public_path__ + "4ac85b3350ec1b5e77f2aa49d4e4fa5d.png";